<div class="modal-main">
  <div
    class="header d-flex justify-content-center align-items-center position-relative pt-3 pb-3 px-4"
  >
    <div class="header-center">
      <span class="header-name">{{ userName }}</span>
      <h1 class="modal-title mb-0">{{ "USER_PROFILE" | translate }}</h1>
    </div>
    <img
      src="/assets/svg/ico-hamburger-close.svg"
      class="cross-button position-absolute pointer-cursor"
      (click)="closeDialog()"
    />
  </div>

  <div class="content">
    <div class="success-icon-container">
      <img
        src="/assets/svg/ico-completed-check.svg"
        alt="account reactivated"
        class="success-icon"
      />
    </div>

    <h2 class="success-title">
      {{ "ACCOUNT_REACTIVATED" | translate }}
    </h2>

    <div class="info-box">
      <span class="info-icon">&#9432;</span>
      <p class="info-text">
        {{ "ACCOUNT_REACTIVATED_INFO" | translate }}
      </p>
    </div>
  </div>

  <div class="popup-footer">
    <button class="btn-done" (click)="onDone()">
      {{ "DONE" | translate }}
    </button>
  </div>
</div>
